'use strict';

export default function f($http, $q, $rootScope, $timeout, userModel, utils, modal) {
  'ngInject';

  return {
    open: function() {
      return new $q((resolve) => {
        let url = utils.getApiUrl(`/membership/${userModel.item.id}/cancellation_reasons`);
        $http.get(url).then((response) => {
          var scope = $rootScope.$new();
          scope.reasons = response.data.subscriptionCancelOptions;
          return resolve(modal.open({
            template: '<sa-cancel-membership-modal done="close()" decline="dismiss()" reasons="reasons"></sa-cancel-membership-modal>',
            scope: scope,
          }).result);
        });
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/modules/membership/cancel_membership/cancel_membership_service.js